import { NgModule } from '@angular/core';
import { BlobToDataUrlPipe } from './blob-to-data-url.pipe';

@NgModule({
  imports: [],
  exports: [
    BlobToDataUrlPipe,
  ],
  declarations: [
    BlobToDataUrlPipe,
  ],
  providers: [],
})
export class BlobUtilsModule {}
